import React from 'react';
import { SxProps, Theme } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';
import { LoadType } from '@paragon/contract-library';
import { getLoadTypeOption } from '@paragon/layout-models';

interface LoadTypeSelectProps {
  loadType: LoadType;
  submit: (loadType: LoadType) => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const manualLoadTypes = ['Dead', 'LiveRoof', 'Wind', 'Rain', 'Snow', 'LiveFloor'] as const;

export function LoadTypeSelect(props: LoadTypeSelectProps) {
  const { disabled, loadType, sx, submit } = props;
  return (
    <PropertySelectField
      sx={sx}
      property="Load Type"
      value={getLoadTypeOption(loadType)}
      options={manualLoadTypes.map(getLoadTypeOption)}
      getName={(option) => option.name}
      getValue={(option) => option.value}
      submit={(loadTypeOption) => void submit(loadTypeOption.value)}
      disabled={disabled}
    />
  );
}
